exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".customer-info-popup {}\r\n\r\n.customer-info-popup-table {}\r\n\r\n.customer-info-popup .customer-info-popup-table td { \r\n    padding-top: 4px; \r\n    padding-bottom: 4px; \r\n    line-height: 16px;\r\n    font-size: 14px;\r\n    letter-spacing: 0.0235294em;\r\n    width: 150px;\r\n}\r\n.customer-info-popup .customer-info-popup-table td:first-child { padding-right: 12px; }\r\n.customer-info-popup .customer-info-popup-table tr:first-child td { padding-top: 0px; }\r\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./ClientApp/components/customer-info-popup/customer-info-popup.css
// module id = 82
// module chunks = 53